import gql from "graphql-tag";

const UPDATE_LEAD_TRAFFIC = gql`
  mutation updateLeadTraffic($input: LeadTrafficUpdateInput!) {
    updateLeadTraffic(input: $input) {
      message
      code
    }
  }
`;

export default UPDATE_LEAD_TRAFFIC;
